import React, { useContext } from "react";
import PlatformContext from "../PlatformContext.jsx";

export default function BackIcon(props: React.ComponentPropsWithoutRef<"svg">) {
  const { platform } = useContext(PlatformContext);

  if (platform === "ios") {
    return (
      <svg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 -960 960 960' width='24px' {...props}>
        <path d='M400-80 0-480l400-400 71 71-329 329 329 329-71 71Z' />
      </svg>
    );
  }

  return (
    <svg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 -960 960 960' width='24px' {...props}>
      <path d='m313-440 224 224-57 56-320-320 320-320 57 56-224 224h487v80H313Z' />
    </svg>
  );
}
